(function () {
	"use strict";

	angular.module("swurveys.maker")
		.factory('imageService', Handler);

	function Handler(
		ModalService,
		swurveysStageConfig,
		$window,
		$q,
		utilsService,
		deleteModal,
		swurveyAdminService
	) {

		var imageService = {};

		function showCropModal(base64ImgObj, aspectRatio) {

			var deferred = $q.defer();

			ModalService.showModal({
					templateUrl: "app/modals/cropper/cropper.html",
					controller: ["$element", "close", function($element, close) {

						var modal = this;

						modal.reset = function() {

							var $srcImg = $('#srcImg');
							$srcImg.cropper('reset');
						};

						modal.close = function(confirm) {

							close(null);

							// Clean up image cropper
							var $srcImg = $('#srcImg');
							var canvas = $srcImg.cropper('getCroppedCanvas');
							$srcImg.cropper('destroy');

							if (confirm === true) {

                var blob = imageService.blobFromDataURL(canvas.toDataURL(), base64ImgObj.fileType);

								deferred.resolve({ blob: blob, canvas : canvas});
							} else {
								deferred.reject({alert: false, msg: 'Image upload cancelled'});
							}
						};

					}],
					controllerAs: "modal"
				})
				.then(function(modal) {
					modal.element.modal();
					modal.close.then(function() {
						$(".modal-backdrop")
							.remove();
					});

					var $srcImg = $('#srcImg');

					$srcImg.attr('src', base64ImgObj.base64Img);

					$('#image-cropper-modal').on('shown.bs.modal', function () {
						$srcImg.cropper({
							aspectRatio: aspectRatio,
							autoCropArea: 1,
							dragMode: 'move'
						});
					});

				});

				return deferred.promise;
		}

        imageService.blobFromDataURL = function(dataUrl, fileType) {
		    var img = dataUrl.split(',')[1];
		    var byteString = $window.atob(img);
  		    var ab = new ArrayBuffer(byteString.length);
  		    var ia = new Uint8Array(ab);

			for (var i = 0; i < byteString.length; i++) {
				ia[i] = byteString.charCodeAt(i);
			}
			return new Blob([ab], { type: fileType });
        };


		imageService.getBase64ImageObj = function(ValidFileTypes) {
			var deferred = $q.defer();

			var fileSelect = document.getElementById('card-image-upload');

			if (fileSelect.disabled) {
				deferred.reject({alert: true, msg: 'File support not available'});
			}

			fileSelect.onchange = function() {

				var file = fileSelect.files[0],
					reader = new FileReader();

				// Check if file type is image
				var fileType = file.type;


				if (ValidFileTypes && $.inArray(fileType, ValidFileTypes) < 0) {
					deferred.reject({alert: true, msg: 'Please select an image file'});
				} else {
					reader.onloadend = function(e) {
						var base64Img = e.target.result; //get base64 encoded file
						deferred.resolve({base64Img: base64Img, fileType: fileType});
					};
				}
				reader.readAsDataURL(file);
				this.value = null;
			};

			fileSelect.click();

			return deferred.promise;
		}

		/**
		 * Uploads image to S3
		 * @param credential		 	AWS credentials
		 * @param data	Reference to card being modified
		 * @returns {*}
		 */

		imageService.uploadImg = function(credential, data, contentType) {

			var deferred = $q.defer();

			if (!credential)
				deferred.reject({msg: 'missing credential object'});

			var params = {
				Bucket: credential.aws.assets,
				Key: 'assets/' + credential.swurveys.identityId() + "/" + utilsService.generateUUID(),
				ContentType: contentType,
				Body: data
			};


			swurveyAdminService.s3.putObject(params, function(err, data) {
				if (err) {
					deferred.reject(err);
				}
				else {
					var imgSrc = swurveysStageConfig.getConfigPropertyValue("asset_distro") + "/" + params.Key;
					deferred.resolve(imgSrc);
				}
			});

			return deferred.promise;
		};

		imageService.getCroppedImageObj = function (aspectRatio) {

			var deferred = $q.defer();

			imageService.getBase64ImageObj(["image/gif", "image/jpeg", "image/png"]).then(function (base64ImgObj) {

				showCropModal(base64ImgObj, aspectRatio).then(function (res) {

                    var croppedImageBlob = res.blob;
                    var canvas = res.canvas;
					deferred.resolve({croppedImageBlob: croppedImageBlob,
					  fileType: base64ImgObj.fileType,
					  width : canvas.width, height : canvas.height});

				}, function (error) {
					deferred.reject(error);
				});
			}, function (error) {
				deferred.reject(error);
			});

			return deferred.promise;
		}

		/**
		 * Confirm removal of background image from CSS class
		 */
		imageService.removeImg = function() {

			var deferred = $q.defer();

			deleteModal.show("Delete",
			"This will delete this image. Are you sure?").then(function (modal) {
					modal.element.modal();
					modal.close.then(function(confirm) {
							if (confirm === true) {
								deferred.resolve();
							}
						});
				});

				return deferred.promise;
		};

		/**
		 * Extract background from css class
		 * @param uri	URI of css class
		 * @returns {*}
		 */
		imageService.extractBG = function(uri) {
			if (!uri || !uri.attributes || !uri.attributes["background-image"])
				return " ";
			uri = uri.attributes["background-image"];
			return uri.substring(uri.lastIndexOf("(") + 1, uri.lastIndexOf(")"));
		};

		return imageService;
	}

}());
